//@ts-nocheck
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import Datepicker from "react-tailwindcss-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { CalendarIcon, CheckIcon, ClockIcon } from 'lucide-react';
import { TimePicker } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';
import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { ChevronDownIcon, CrossIcon } from '../../icons/Icons';
import timezonesData from '../../../utils/timezones.json';
import "../../../styles/resuit.css"
import { createMeeting, fetchMeetingList, updateMeetingData } from '../../../features/meeting/MeetingSlice';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { toast } from 'sonner';
import { fetchReviewListByJobId } from '../../../features/review/reviewSlice';
import { fetchScoreCardPipelineDetailsData } from '../../../features/scorecard/scoreCardSlice';

const durationOptions = [
  { value: '15', label: '15 minutes' },
  { value: '30', label: '30 minutes' },
  { value: '45', label: '45 minutes' },
  { value: '60', label: '1 hour' },
  { value: '120', label: '2 hours' },
  { value: '180', label: '3 hours' },
  { value: '240', label: '4 hours' },
  { value: '300', label: '5 hours' },
  { value: '360', label: '6 hours' },
  { value: '420', label: '7 hours' },
  { value: '480', label: '8 hours' }
];



const locationOptions = [
  { value: 'office', label: 'Office' },
  { value: 'video', label: 'Video' },
  { value: 'phone', label: 'Phone' }
];


// Auto-resizing textarea component
const AutoResizeTextarea = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      // Set initial height to 40px
      textareaRef.current.style.height = "60px";
      // Reset height to auto to get the correct scrollHeight
      textareaRef.current.style.height = "auto";
      // Set the height based on scrollHeight with a minimum of 40px
      textareaRef.current.style.height = `${Math.max(60, textareaRef.current.scrollHeight)}px`;
    }
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      className="resize-none outline-none bg-transparent focus:border-light-gray-200 focus:outline-none focus:!shadow-none focus:ring-transparent !ring-0 text-[14px]
       text-dark-black-100 w-full m-0 placeholder:text-[#9e9ea0] 
      border
       border-solid border-light-gray-200 rounded-md p-2"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={1}
    />
  );
};


function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const timezones = timezonesData.map(tz => ({
  // value: tz.value,  // Make sure this exists
  label: tz.text,
  abbr: tz.abbr,
  utc: tz.utc
}));

export default function UpdateMeeting({ opneMeeting, setOpenMeeting, applicationDetails, meetingList, setMeetingList, selectedMeeting, job: jobProp, app: appProp, quickData }: any) {
  
  const [candidateName, setCandidateName] = useState('');
  const [candidateEmail, setCandidateEmail] = useState('');
  const [meetingDate, setMeetingDate] = useState({
    startDate: new Date(),
    endDate: new Date()
  });
  const [meetingTime, setMeetingTime] = useState<Date | null>(null);
  const [timezone, setTimezone] = useState('GMT');
  const [duration, setDuration] = useState(durationOptions[0]); // Default to the first option
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [organisedData, setOrganisedData] = useState(null)
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [jobTeamMembers, setJobTeamMembers] = useState([]);
  const [message, setMessage] = useState("");
  // Add these state variables to your component
  const [fromTime, setFromTime] = useState(null);
  const [toTime, setToTime] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [location, setLocation] = useState(locationOptions[0]); // Default to the first option
  const [locationDetails, setLocationDetails] = useState('')
  const [jobScoreCard, setJobScoreCard] = useState([]);
  const [selectedScoreCard, setSelectedScoreCard] = useState(null);
  const [interviewGuide, setInterviewGuide] = useState('')
  const { baseId, jobId: jobIdFromParams, applicationId: applicationIdFromParams } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedParticipants1, setSelectedParticipants1] = useState(null);
  const [reviewTemplates, setReviewTemplates] = useState([]);



  // Add this filtering logic 
  const filteredTimezones = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return timezones;

    return timezones.filter(zone =>
      zone.abbr.toLowerCase().includes(query) ||
      zone.label.toLowerCase().includes(query) ||
      zone.utc.some(utc => utc.toLowerCase().includes(query))
    );
  }, [timezones, searchQuery]);





  // Fetch job team members from local storage on component mount
  useEffect(() => {
    const storedJobTeamMembers = JSON.parse(localStorage.getItem("jobByHiringTeamMembers") || "[]");
    setJobTeamMembers(storedJobTeamMembers);
  }, []);


    useEffect(() => {
      const fetchReviewTemplates = async () => {
        try {
          const response = await dispatch(
            fetchReviewListByJobId({
              baseId: Number(baseId),
              jobId: jobId
            })
          );
  
          if (response.payload) {
            setReviewTemplates(response.payload.data);
          }
        } catch (error) {
          toast.error('Failed to fetch review templates');
        }
      };
  
      if (baseId && jobId) {
        fetchReviewTemplates();
      }
    }, [baseId, jobId, dispatch]);

  // Fetch job team jobscorecard from local storage on component mount
  useEffect(() => {
    if (!baseId || !jobId) return;

    const fetchTeams = async () => {
      const storedData = localStorage.getItem("baseScoreCardDataByJob");

      if (storedData) {

        const parsedData = JSON.parse(storedData);
        const scoreCards = Array.isArray(parsedData.data)
          ? parsedData.data
          : parsedData.data ? [parsedData.data] : [];

        setJobScoreCard(scoreCards);

        // Set the first scorecard as selected by default if available
        if (scoreCards.length > 0) {
          setSelectedScoreCard(scoreCards[0]);
        }
      }
      else {
        try {
          const response = await dispatch(
            fetchScoreCardPipelineDetailsData({
              baseId: Number(baseId),
              JobId: jobId
            })
          ).unwrap();


          const scoreCards = Array.isArray(response?.data)
            ? response?.data
            : response?.data ? [response?.data] : [];
          setJobScoreCard(scoreCards);

          localStorage.setItem(
            "baseScoreCardDataByJob",
            JSON.stringify(response)
          );
        } catch (error) {
          console.error("Error fetching scorecard data:", error);
        }
      }
    };

    fetchTeams();
  }, [baseId, jobId]);

  // Find participants from baseMembers using user_ids from jobTeamMembers
  const availableParticipants = useMemo(() => {
    return jobTeamMembers.map(teamMember => {      
      const baseMember = baseMembers.find(member => member.user_id === teamMember.user_id);

      return {
        id: teamMember.user_id,
        name: teamMember.name,
        newId: teamMember.id

      };
    }).filter(participant => participant.name);
  }, [jobTeamMembers, baseMembers]);



  // Load meeting data when selectedMeeting changes
  useEffect(() => {
    if (selectedMeeting) {
      // Parse date
      const meetingDateObj = new Date(selectedMeeting.date);
      setMeetingDate({
        startDate: meetingDateObj,
        endDate: meetingDateObj
      });

      // Parse times
      if (selectedMeeting.from_time) {
        const [hours, minutes] = selectedMeeting.from_time.split(':');
        const fromTimeDate = new Date();
        fromTimeDate.setHours(parseInt(hours), parseInt(minutes), 0);
        setFromTime(fromTimeDate);
      }

      if (selectedMeeting.till_time) {
        const [hours, minutes] = selectedMeeting.till_time.split(':');
        const toTimeDate = new Date();
        toTimeDate.setHours(parseInt(hours), parseInt(minutes), 0);
        setToTime(toTimeDate);
      }

      // Set other fields
      setMessage(selectedMeeting.details || '');
      setTimezone(selectedMeeting.timezone || 'UTC');
      setLocationDetails(selectedMeeting.location_details || '');

      // Find the matching location option
      const foundLocation = locationOptions.find(opt => opt.value === selectedMeeting.location);
      if (foundLocation) {
        setLocation(foundLocation);
      }

      // Set organiser
      const organiser = baseMembers.find(member => member.user_id === selectedMeeting.organiser);
      if (organiser) {
        setOrganisedData(organiser);
      }

      // Set participants/hosts
      if (selectedMeeting.hosts) {
        const hostIds = selectedMeeting.hosts.split(',').map(id => id.trim());
        const selectedHosts = availableParticipants.filter(participant =>
          hostIds.includes(participant.id.toString())
        );
        setSelectedParticipants(selectedHosts);
      }

      // Set scorecard and interview guide if they exist
      if (selectedMeeting.scorecard_id) {
        const scorecard = jobScoreCard.find(card => card.id === selectedMeeting.scorecard_id);
        if (scorecard) {
          setSelectedScoreCard(scorecard);
        }
      }

      setInterviewGuide(selectedMeeting.interview_guide_id || '');
      // Set selected participants for review template
      if (selectedMeeting.review_template_id) {
        const reviewTemplate = reviewTemplates.find(participant => participant.id === selectedMeeting.review_template_id);
        
        if (reviewTemplate) {
          
          setSelectedParticipants1(reviewTemplate);
        }
      } else {
        setSelectedParticipants1(null);
      }
    }
  }, [selectedMeeting]);





  // Handle participant selection
  const toggleParticipant = (participant) => {
    setSelectedParticipants(current => {
      const isSelected = current.some(item => item.id === participant.id);
      if (isSelected) {
        return current.filter(item => item.id !== participant.id);
      } else {
        return [...current, participant];
      }
    });
  };

  const handleSave = async () => {
    // Set loading state to true
    setIsLoading(true);

    try {
      // Format the date in YYYY-MM-DD format
      const date = new Date(meetingDate.startDate);
      const formattedDate = date.toISOString().split('T')[0]; // Get YYYY-MM-DD format

      // Format time in HH:MM:SS format
      const formatTimeString = (timeObj) => {
        if (!timeObj) return null;
        let hours = timeObj.getHours().toString().padStart(2, '0');
        let minutes = timeObj.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}:00`;
      };

      // Combine selected participants IDs into a comma-separated string
      const participantIds = selectedParticipants.map(participant => participant.id).join(',');

      // Create meeting payload according to the required API format
      const meetingPayload = {
        job_id: jobId,
        app_id: applicationId,
        date: formattedDate,
        from_time: formatTimeString(fromTime),
        // till_time: formatTimeString(toTime),
        timezone: timezone,
        till_time: Number(duration.value).toString(), // Use duration value as string
        organiser: organisedData?.user_id,
        hosts: participantIds, // Comma-separated string of IDs
        details: message,
        location: location.value,
        location_details: locationDetails,
        stage_id: applicationDetails?.stage_id || '',
        scorecard_id: selectedScoreCard?.id || '',
        // interview_guide_id: interviewGuide || '',
        review_template_id: selectedParticipants1?.id?.toString(),
        // current_state: "pending"
      };

      

      // Dispatch the updateMeeting action
      const updateMeetingResponse = await dispatch(updateMeetingData({
        payload: meetingPayload,
        baseId,
        id: selectedMeeting?.id
      })).unwrap();

      if (updateMeetingResponse.status === 200) {
        toast.success('Meeting update successfully');
      }


      // Close the meeting modal
      setOpenMeeting(false);

      // Fetch the updated meeting list
      const fetchMeetingResponse = await dispatch(fetchMeetingList({
        baseId: parseInt(baseId),
        appId: applicationId
      })).unwrap();

      // Update the meeting list state
      setMeetingList(fetchMeetingResponse.data);

      // Log the response for debugging
    } catch (error) {
      // Show error toast
      toast.error('Failed to update meeting');
    } finally {
      // Reset loading state
      setIsLoading(false);
    }
  };



  return (
    <Dialog open={opneMeeting} onClose={() => setOpenMeeting(false)} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4
             data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[50rem] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-t-md">
              <div className="sm:flex sm:items-start">
                <div className=" w-full">
                  <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                    Update Meeting
                  </DialogTitle>
                  <div className="absolute right-[7px] top-[7px] hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setOpenMeeting(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon />
                    </button>
                  </div>
                  <div className="mt-4">
                    <div className='bg-[#e0e0e0] w-full h-[1px] mb-0' />
                    <label htmlFor="candidateName" className="block text-sm font-normal text-gray-700 py-3">
                      {applicationDetails?.app_name} ({applicationDetails?.app_email})
                    </label>
                    <div className='bg-[#e0e0e0] w-full h-[1px] mb-0' />
                    <form className="space-y-4">

                      {/* 
                      <div>
                        <label htmlFor="candidateEmail" className="block text-sm font-medium text-gray-700">
                          Email ID
                        </label>
                        <input
                          type="email"
                          id="candidateEmail"
                          className="w-full px-3 py-1 border mt-1.5 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                          value={candidateEmail}
                          onChange={(e) => setCandidateEmail(e.target.value)}
                        />
                      </div> */}

                      <div className='pt-4 mb-[-5px]'>
                        <h2 className="text-sm font-medium text-gray-900 mb-1.5">Meeting Details</h2>
                        <AutoResizeTextarea
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          placeholder="Write a message..."
                        />
                      </div>

                      <div className="">


                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label htmlFor="meetingDate" className="block text-sm font-medium text-gray-700 mb-1.5">
                              Date
                            </label>
                            <div className="relative ">
                              <Datepicker
                                useRange={false}
                                asSingle={true}
                                value={meetingDate || {
                                  startDate: new Date(),
                                  endDate: new Date()
                                }}
                                onChange={(date) => setMeetingDate(date)}
                                // showShortcuts={true}
                                displayFormat={"MMMM DD, YYYY - dddd"}
                                inputClassName=" w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm"
                              />
                            </div>
                          </div>
                          <div>
                            <div>
                              {/* <label htmlFor="meetingTime" className="block text-sm font-medium text-gray-700 mb-1.5">
                                Time
                              </label> */}
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <div className="block text-sm font-medium text-gray-700 mb-1.5">Time</div>
                                  <TimePicker
                                    format="hh:mm aa"
                                    showMeridiem
                                    hideMinutes={minute => minute % 15 !== 0}
                                    value={fromTime}
                                    cleanable={false}
                                    onChange={value => setFromTime(value)}
                                    style={{
                                      width: '100%',
                                      borderRadius: '0.375rem',
                                      fontSize: '0.875rem',
                                    }}
                                  />
                                </div>
                                <div>
                                  <div className="block text-sm font-medium text-gray-700 mb-1.5">
                                    <div>

                                      <Listbox value={timezone} onChange={setTimezone}>
                                        {({ open }) => (
                                          <div className="relative mt-[-5px] text-right flex justify-end">
                                            <Listbox.Button
                                              className=" text-[13px] text-[#266df0] line-clamp-1 grid mb-1.5"
                                            >
                                              <span className="block truncate line-clamp-1">
                                                {timezones.find((tz) => tz.label === timezone)
                                                  ? `${timezones.find((tz) => tz.label === timezone)?.abbr} - ${timezones.find((tz) => tz.label === timezone)?.label}`
                                                  : 'Select Timezone'}

                                              </span>

                                            </Listbox.Button>
                                            <Transition
                                              as={Fragment}
                                              leave="transition ease-in duration-100"
                                              leaveFrom="opacity-100"
                                              leaveTo="opacity-0"
                                            >
                                              <Listbox.Options className="  absolute top-[28px] z-10 mt-[2px] left-[-63px] bg-white w-full max-w-[240px] min-w-[240px] rounded-lg border border-border
                                                                           bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out
                                                                            data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95
                                                                             data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                                                                              data-[side=top]:slide-in-from-bottom-2">
                                                <div className="sticky top-0 z-10 bg-white p-1">
                                                  <div className="relative">
                                                    <input
                                                      type="text"
                                                      className="w-full px-3 py-1 border mt-1.5 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm"
                                                      placeholder="Search timezone..."
                                                      value={searchQuery}
                                                      onChange={(e) => setSearchQuery(e.target.value)}
                                                      onClick={(e) => e.stopPropagation()}
                                                      onKeyDown={(e) => e.key === ' ' && e.stopPropagation()}
                                                    />
                                                    <div className="absolute top-[6px] bottom-0 right-0 flex items-center pr-2">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={16}
                                                        height={16}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="text-gray-400"
                                                      >
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                                        <path d="M21 21l-6 -6" />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="overflow-auto max-h-[180px] mt-1">
                                                  {filteredTimezones.length > 0 ? (
                                                    filteredTimezones.map((tz) => (
                                                      <Listbox.Option
                                                        key={tz.label}
                                                        value={tz.label}
                                                        className={({ active }) =>
                                                          classNames(
                                                            active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                                            'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                                          )
                                                        }
                                                      >
                                                        {({ selected }) => (
                                                          <>
                                                            <span
                                                              className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
                                                            >
                                                              {tz.label}
                                                            </span>
                                                            {selected && (
                                                              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  width={24}
                                                                  height={24}
                                                                  viewBox="0 0 24 24"
                                                                  fill="none"
                                                                  stroke="currentColor"
                                                                  strokeWidth={2}
                                                                  strokeLinecap="round"
                                                                  strokeLinejoin="round"
                                                                  className="w-4 h-4"
                                                                >
                                                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                  <path d="M5 12l5 5l10 -10" />
                                                                </svg>
                                                              </span>
                                                            )}
                                                          </>
                                                        )}
                                                      </Listbox.Option>
                                                    ))
                                                  ) : (
                                                    <div className="px-2 py-1.5 text-sm text-gray-500">No timezone found</div>
                                                  )}
                                                </div>
                                              </Listbox.Options>
                                            </Transition>
                                          </div>
                                        )}
                                      </Listbox>
                                    </div>
                                  </div>
                                  <Listbox value={duration} onChange={setDuration}>
                                    <div className="relative mt-1.5">
                                      <Listbox.Button className=" w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                                                    text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                                                     focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50  [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                                                     border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3  py-2">
                                        <span className="block truncate font-normal">{duration.label}</span>
                                        <span className="pointer-events-none">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="w-4 h-4 text-gray-500"
                                          >
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M6 9l6 6l6 -6" />
                                          </svg>
                                        </span>
                                      </Listbox.Button>

                                      <Transition
                                        as={Fragment}
                                        leave="transition ease-in duration-100"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                      >
                                        <Listbox.Options className=" overflow-auto max-h-[180px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                          {durationOptions.map((option) => (
                                            <Listbox.Option
                                              key={option.value}
                                              value={option}

                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                                  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                                )
                                              }
                                            >
                                              {({ selected }) => (
                                                <>
                                                  <span
                                                    className={`block truncate font-normal ${selected ? 'font-normal' : 'font-normal'
                                                      }`}
                                                  >
                                                    {option.label}
                                                  </span>
                                                  {selected && (
                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="w-4 h-4"
                                                      >
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M5 12l5 5l10 -10" />
                                                      </svg>
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))}
                                        </Listbox.Options>
                                      </Transition>
                                    </div>
                                  </Listbox>
                                  {/* <TimePicker
                                    format="hh:mm aa"
                                    showMeridiem
                                    value={toTime}
                                    cleanable={false}
                                    onChange={value => setToTime(value)}
                                    style={{
                                      width: '100%',
                                      borderRadius: '0.375rem',
                                      fontSize: '0.875rem',
                                    }}
                                  /> */}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>


                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="organisedBy" className="block text-sm font-medium text-gray-700">
                            Organised by
                          </label>
                          <Listbox value={organisedData} onChange={setOrganisedData}>
                            <div className="relative mt-1.5">
                              {/* Listbox Button */}
                              <Listbox.Button className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
        text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
        focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
        border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2">
                                <span className="block truncate font-normal">
                                  {organisedData ? organisedData.name : "Select organiser"}
                                </span>
                                <span className="pointer-events-none">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-4 h-4 text-gray-500"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M6 9l6 6l6 -6" />
                                  </svg>
                                </span>
                              </Listbox.Button>

                              {/* Listbox Options */}
                              <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className="overflow-auto max-h-[180px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                  {baseMembers.map((member) => (
                                    <Listbox.Option
                                      key={member.id}
                                      value={member}
                                      className={({ active }) =>
                                        classNames(
                                          active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                          'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                        )
                                      }
                                    >
                                      {({ selected }) => (
                                        <>
                                          <span
                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
                                          >
                                            {member.name}
                                          </span>
                                          {selected && (
                                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="w-4 h-4"
                                              >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M5 12l5 5l10 -10" />
                                              </svg>
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </Listbox.Option>
                                  ))}
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </Listbox>
                        </div>

                        <div className="">
                          <label htmlFor="participants" className="block text-sm font-medium text-gray-700">
                            hosts
                          </label>
                          <div className="relative mt-1.5">
                            <Listbox value={selectedParticipants} onChange={setSelectedParticipants} multiple>
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button
                                      className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2"
                                    >
                                      <span className="block truncate font-normal">
                                        {selectedParticipants.length === 0
                                          ? "Select participants"
                                          : `${selectedParticipants.length} participant(s) selected`}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="overflow-auto max-h-[120px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                        {availableParticipants.length > 0 ? (
                                          availableParticipants.map((participant) => (
                                            <Listbox.Option
                                              key={participant.id}

                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                                  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                                )
                                              }
                                              value={participant}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <div className="flex items-center">
                                                    <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                                                      {participant.name}
                                                    </span>
                                                  </div>

                                                  {selected ? (
                                                    <span
                                                      className={`absolute inset-y-0 right-0 flex items-center pr-4 ${active ? 'text-white' : 'text-indigo-600'
                                                        }`}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))
                                        ) : (
                                          <div className="px-3 py-2 text-sm text-gray-500">No participants available</div>
                                        )}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>

                          {/* Display selected participants */}
                          {selectedParticipants.length > 0 && (
                            <div className="mt-2 flex flex-wrap gap-2">
                              {selectedParticipants.map(participant => (
                                <div key={participant.id} className="flex items-center rounded-md bg-indigo-100 px-2 py-1 text-sm">
                                  <span className="text-indigo-800">{participant.name}</span>
                                  <button
                                    type="button"
                                    onClick={() => toggleParticipant(participant)}
                                    className="ml-1 text-indigo-600 hover:text-indigo-800"
                                  >
                                    <span className="sr-only">Remove</span>
                                    <CrossIcon className="h-4 w-4" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className='grid grid-cols-2 gap-4'>
                        <div>
                          <label htmlFor="duration" className="block text-sm font-medium text-gray-700">
                            Location
                          </label>
                          <Listbox value={location} onChange={setLocation}>
                            <div className="relative mt-1.5">
                              <Listbox.Button className=" w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                  text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                   focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50  [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                   border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3  py-2">
                                <span className="block truncate font-normal">{location.label}</span>
                                <span className="pointer-events-none">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-4 h-4 text-gray-500"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M6 9l6 6l6 -6" />
                                  </svg>
                                </span>
                              </Listbox.Button>

                              <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className=" overflow-auto max-h-[180px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                  {locationOptions.map((option) => (
                                    <Listbox.Option
                                      key={option.value}
                                      value={option}

                                      className={({ active }) =>
                                        classNames(
                                          active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                          'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                        )
                                      }
                                    >
                                      {({ selected }) => (
                                        <>
                                          <span
                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                              }`}
                                          >
                                            {option.label}
                                          </span>
                                          {selected && (
                                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="w-4 h-4"
                                              >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M5 12l5 5l10 -10" />
                                              </svg>
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </Listbox.Option>
                                  ))}
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </Listbox>
                        </div>
                        <div>
                          <label htmlFor="locationDetails" className="block text-sm font-medium text-gray-700">
                            Location details
                          </label>
                          <input
                            type="text"
                            id="locationDetails"
                            className="w-full px-3 py-1.5 border mt-1.5 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                            value={locationDetails}
                            onChange={(e) => setLocationDetails(e.target.value)}
                          />
                        </div>
                      </div>



                      <div className="grid grid-cols-2 gap-4">
                        {/* commented on 2/dec/25 */}
                        {/* <div>
                          <label htmlFor="organisedBy" className="block text-sm font-medium text-gray-700">
                            Scorecard
                          </label>
                          <Listbox value={selectedScoreCard} onChange={setSelectedScoreCard}>
                            <div className="relative mt-1.5">
                              <Listbox.Button className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
      text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
      focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
      border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2">
                                <span className="block truncate font-normal">
                                  {selectedScoreCard ? selectedScoreCard.scorecard_name : "Select scorecard"}
                                </span>
                                <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                              </Listbox.Button>

                              <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className="overflow-auto max-h-[180px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5">
                                  {Array.isArray(jobScoreCard) && jobScoreCard.length > 0 ? (
                                    jobScoreCard.map((card) => (
                                      <Listbox.Option
                                        key={card.id || `card-${Math.random()}`}
                                        value={card}
                                        className={({ active }) =>
                                          classNames(
                                            active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                            'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors'
                                          )
                                        }
                                      >
                                        {({ selected }) => (
                                          <>
                                            <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                                              {card.scorecard_name}
                                            </span>
                                            {selected && (
                                              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                                <CheckIcon className="w-4 h-4" />
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </Listbox.Option>
                                    ))
                                  ) : (
                                    <div className="py-2 px-3 text-sm text-gray-500">No scorecards available</div>
                                  )}
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </Listbox>
                        </div>
                        <div>
                          <label htmlFor="participants" className="block text-sm font-medium text-gray-700">
                            Review Template
                          </label>
                          <div className="relative mt-1.5">
                            <Listbox value={selectedParticipants1} onChange={setSelectedParticipants1}>
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button
                                      className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                                        text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                                        focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                                        border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2"
                                    >
                                      <span className="block truncate font-normal">
                                        {selectedParticipants1 ? selectedParticipants1.review_name : "Select review template"}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="overflow-auto max-h-[120px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                        {reviewTemplates.length > 0 ? (
                                          reviewTemplates.map((participant) => (
                                            <Listbox.Option
                                              key={participant.id}

                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                                  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                                )
                                              }
                                              value={participant}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <div className="flex items-center">
                                                    <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                                                      {participant.review_name}
                                                    </span>
                                                  </div>

                                                  {selected ? (
                                                    <span
                                                      className={`absolute inset-y-0 right-0 flex items-center pr-4 ${active ? 'text-white' : 'text-indigo-600'
                                                        }`}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))
                                        ) : (
                                          <div className="px-3 py-2 text-sm text-gray-500">No review template available</div>
                                        )}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>

                        </div> */}

                        {/* <div>
                          <label htmlFor="locationDetails" className="block text-sm font-medium text-gray-700">
                            Interview Guide
                          </label>
                          <input
                            type="text"
                            id="interviewguide"
                            className="w-full px-3 py-1.5 border mt-1.5 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                            value={interviewGuide}
                            onChange={(e) => setInterviewGuide(e.target.value)}
                          />
                        </div> */}
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-md">
              <button
                type="button"
                onClick={handleSave}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
              >
                {isLoading ? (
                  <div className='flex items-center gap-[6px]'>
                    Schedule Meeting
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  </div>
                ) : (
                  ' Schedule Meeting'
                )}

              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => setOpenMeeting(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}